import { ArrowLeftIcon, BackwardArrow } from 'assets/icons';
import { t } from 'i18next';
import React from 'react';
import { useNewMobileUiManager } from 'shared/hooks/useNewMobileUiManager';
import useSectionNavigation from 'shared/hooks/useSectionNavigation';

interface Props {
	className?: string;
	title: string;
	onGoBack?: () => void;
}

const CpHeader: React.FC<Props> = (props) => {
	const { goToParentView } = useSectionNavigation();
	const { title, className, onGoBack = goToParentView } = props;
	const showNewUI = useNewMobileUiManager();
	return showNewUI ? (
		<div className={`cp-header ${className}`}>
			<div className="flex items-center gap-1 relative z-[1]" onClick={onGoBack} data-cy="header-back">
				<ArrowLeftIcon />
				<div className="font-normal text-white">{t('quit')}</div>
			</div>
			<span className="font-semibold text-l text-white absolute left-0 right-0 flex items-center justify-center">{title}</span>
		</div>
	) : (
		<div className={`cp-header ${className}`}>
			<span className="cp-header__icon " onClick={onGoBack} data-cy="header-back">
				<BackwardArrow className="fill--white" />
				<span className="cp-header__title">{title}</span>
			</span>
		</div>
	);
};

export default CpHeader;
